export enum LevelErrors {
  DELETE = 'levels/deleteLevel',
  CREATE = 'levels/createLevel',
  EDIT = 'levels/editLevel',
  GET = 'levels/getLevel'
}
